/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{writeAttributes as t}from"./internal/bufferWriterUtils.js";class e{constructor(t){this.layout=t}elementCount(t){return t.get("position").indices.length}write(e,r,i,n,o){null!=o&&t(i,n,this.layout,e,r,o)}}export{e as DefaultBufferWriter};
